export default "__VITE_ASSET__CkU7vMUA__"